export var calculateLabelTopPosition = function (labelHeight, height, optionalPadding) {
  if (height === void 0) {
    height = 0;
  }
  if (optionalPadding === void 0) {
    optionalPadding = 0;
  }
  var customHeight = height > 0 ? height : 0;
  return Math.floor((customHeight - labelHeight) / 2 + optionalPadding);
};
export var calculateInputHeight = function (labelHeight, height, minHeight) {
  if (height === void 0) {
    height = 0;
  }
  var finalHeight = height > 0 ? height : labelHeight;
  if (height > 0) return height;
  return finalHeight < minHeight ? minHeight : finalHeight;
};
export var calculatePadding = function (props) {
  var height = props.height,
    _a = props.multiline,
    multiline = _a === void 0 ? false : _a;
  var result = 0;
  if (multiline) {
    if (height && multiline) {
      result = calculateTextAreaPadding(props);
    } else {
      result = calculateInputPadding(props);
    }
  }
  return Math.max(0, result);
};
var calculateTextAreaPadding = function (props) {
  var dense = props.dense;
  return dense ? 10 : 20;
};
var calculateInputPadding = function (_a) {
  var topPosition = _a.topPosition,
    fontSize = _a.fontSize,
    multiline = _a.multiline,
    scale = _a.scale,
    dense = _a.dense,
    offset = _a.offset,
    isAndroid = _a.isAndroid;
  var refFontSize = scale * fontSize;
  var result = Math.floor(topPosition / 2);
  result = result + Math.floor((refFontSize - fontSize) / 2) - (scale < 1 ? offset / 2 : 0);
  if (multiline && isAndroid) result = Math.min(dense ? offset / 2 : offset, result);
  return result;
};
export var adjustPaddingOut = function (_a) {
  var pad = _a.pad,
    multiline = _a.multiline,
    label = _a.label,
    scale = _a.scale,
    height = _a.height,
    fontSize = _a.fontSize,
    dense = _a.dense,
    offset = _a.offset,
    isAndroid = _a.isAndroid;
  var refFontSize = scale * fontSize;
  var result = pad;
  if (height) {
    return {
      paddingTop: Math.max(0, (height - fontSize) / 2),
      paddingBottom: Math.max(0, (height - fontSize) / 2)
    };
  }
  if (!isAndroid && multiline) {
    if (dense) {
      if (label) {
        result += scale < 1 ? Math.min(offset, refFontSize / 2 * scale) : 0;
      } else {
        result += 0;
      }
    }
    if (!dense) {
      if (label) {
        result += scale < 1 ? Math.min(offset, refFontSize * scale) : Math.min(offset / 2, refFontSize * scale);
      } else {
        result += scale < 1 ? Math.min(offset / 2, refFontSize * scale) : 0;
      }
    }
    result = Math.floor(result);
  }
  return {
    paddingTop: result,
    paddingBottom: result
  };
};
export var adjustPaddingFlat = function (_a) {
  var pad = _a.pad,
    scale = _a.scale,
    multiline = _a.multiline,
    label = _a.label,
    height = _a.height,
    offset = _a.offset,
    dense = _a.dense,
    fontSize = _a.fontSize,
    isAndroid = _a.isAndroid,
    styles = _a.styles;
  var result = pad;
  var topResult = result;
  var bottomResult = result;
  var paddingTop = styles.paddingTop,
    paddingBottom = styles.paddingBottom;
  var refFontSize = scale * fontSize;
  if (!multiline) {
    // do not modify padding if input is not multiline
    if (label) {
      // return const style for flat input with label
      return {
        paddingTop: paddingTop,
        paddingBottom: paddingBottom
      };
    }
    // return pad for flat input without label
    return {
      paddingTop: result,
      paddingBottom: result
    };
  }
  if (label) {
    // add paddings passed from styles
    topResult = paddingTop;
    bottomResult = paddingBottom;
    // adjust top padding for iOS
    if (!isAndroid) {
      if (dense) {
        topResult += scale < 1 ? Math.min(result, refFontSize * scale) - result / 2 : Math.min(result, refFontSize * scale) - result / 2;
      }
      if (!dense) {
        topResult += scale < 1 ? Math.min(offset / 2, refFontSize * scale) : Math.min(result, refFontSize * scale) - offset / 2;
      }
    }
    topResult = Math.floor(topResult);
  } else {
    if (height) {
      // center text when height is passed
      return {
        paddingTop: Math.max(0, (height - fontSize) / 2),
        paddingBottom: Math.max(0, (height - fontSize) / 2)
      };
    }
    // adjust paddings for iOS if no label
    if (!isAndroid) {
      if (dense) {
        result += scale < 1 ? Math.min(offset / 2, fontSize / 2 * scale) : Math.min(offset / 2, scale);
      }
      if (!dense) {
        result += scale < 1 ? Math.min(offset, fontSize * scale) : Math.min(fontSize, offset / 2 * scale);
      }
      result = Math.floor(result);
      topResult = result;
      bottomResult = result;
    }
  }
  return {
    paddingTop: Math.max(0, topResult),
    paddingBottom: Math.max(0, bottomResult)
  };
};
export var interpolatePlaceholder = function (labeled, hasActiveOutline) {
  return labeled.interpolate({
    inputRange: [0, 1],
    outputRange: [hasActiveOutline ? 0 : 1, 1]
  });
};